interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}
export default function PageHeader({ title, subtitle, children }: PageHeaderProps) {
  return (
    <header className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
        {subtitle && (
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        )}
      </div>
      {children && <div className="flex gap-2">{children}</div>}
    </header>
  );
}
